import { createSlice } from "@reduxjs/toolkit";
import { Notification, Meta } from "src/store/types";
import {
  doFetchNotificationList,
  doFetchUnreadNotificationCount,
} from "./notification.action";

interface NotificationState {
  notifications: Notification[];
  meta: Meta | null;
  unreadCount: number;
  loading: boolean;
  unreadCountLoading: boolean;
  error: string | null;
}

const initialState: NotificationState = {
  notifications: [],
  meta: null,
  unreadCount: 0,
  loading: false,
  unreadCountLoading: false,
  error: null,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    clearNotifications: (state) => {
      state.notifications = [];
      state.meta = null;
    },
    resetUnreadCount: (state) => {
      state.unreadCount = 0;
    },
    markAsRead: (state, action) => {
      const notificationId = action.payload;
      const notification = state.notifications.find(
        (n) => n.id === notificationId
      );
      if (notification && !notification.isNotificationRead) {
        notification.isNotificationRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
  },
  extraReducers: (builder) => {
    // fetch notification list
    builder
      .addCase(doFetchNotificationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchNotificationList.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchNotificationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "An error occurred";
      });

    // fetch unread notification count
    builder
      .addCase(doFetchUnreadNotificationCount.pending, (state) => {
        state.unreadCountLoading = true;
        state.error = null;
      })
      .addCase(doFetchUnreadNotificationCount.fulfilled, (state, action) => {
        state.unreadCountLoading = false;
        state.unreadCount = action.payload.data.unreadNotificationCount || 0;
      })
      .addCase(doFetchUnreadNotificationCount.rejected, (state, action) => {
        state.unreadCountLoading = false;
        state.error =
          (typeof action.payload === "string" && action.payload) ||
          action.error?.message ||
          "An error occurred";
      });
  },
});

// Export actions
export const { clearNotifications, resetUnreadCount, markAsRead } =
  notificationSlice.actions;

export default notificationSlice.reducer;
